import { render, staticRenderFns } from "./EventPageV2.vue?vue&type=template&id=0e2f12fa&scoped=true&lang=pug"
import script from "./EventPageV2.vue?vue&type=script&lang=js"
export * from "./EventPageV2.vue?vue&type=script&lang=js"
import style0 from "./EventPageV2.vue?vue&type=style&index=0&id=0e2f12fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2f12fa",
  null
  
)

export default component.exports